<template>
        <div class="p-fluid formgrid grid">
            <div class="field col-12">
                <Image
                    src="https://treetan-storage.is3.cloudhost.id/uploads-production/0000/1/2021/09/29/rekanan-travel-dengan.webp"
                    preview="true"
                    width="250"
                />
            </div>
            <div class="field col-12 md:col-3">
                <label for="name3">Applied Vacant</label>
                <InputText id="id_card_number" type="text" v-model="model.vacancies_id" readonly />
            </div>
            <div class="field col-12 md:col-4">
                <label for="name3">Name</label>
                <InputText id="name" type="text" v-model="model.name" :disabled="isDisabled" readonly/>
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">Gender</label>
                <Dropdown v-model="model.gender" :options="genderValues" optionLabel="name" optionValue="code" placeholder="Select Gender" :class="{'p-invalid' : submitted && !model.gender}" :disabled="isDisabled" readonly/>
                    <small class="p-invalid" v-if="submitted && !model.gender"
                        >Gender is required.</small
                    >
            </div>
            <div class="field col-12 md:col-2">
                <label for="email3">Age</label>
                <InputText id="age" type="number" v-model="model.age" :disabled="isDisabled" readonly />
            </div>
            <div class="field col-12 md:col-4">
                <label for="placement">Placement</label>
                <Dropdown v-model="form.placement_id" placeholder="Select Placement"/>
            </div>
            <div class="field col-12 md:col-4">
                <label for="placement">Division</label>
                <Dropdown v-model="form.division_id" placeholder="Select Division"/>
            </div>
            <div class="field col-12 md:col-4">
                <label for="placement">Position</label>
                <Dropdown v-model="form.position_id" placeholder="Select Position"/>
            </div>
        </div>
</template>
<script>
import axios from 'axios';
import { FilterMatchMode } from "primevue/api";
import InputText from 'primevue/inputtext';
import Button from "primevue/button";
import Image from "primevue/image";
import TextArea from "primevue/textarea";
import Dropdown from "primevue/dropdown";
import Calendar from 'primevue/calendar';
import DatatableService from "../../../../Services/DatatableService";

export default {
    components:{
        Button,
        InputText,
        TextArea,
        Dropdown,
        Calendar,
        Image,
    },
    props: ['isDisabled','model'],
    data(){
        return{
            form: {},
            genderValues: [
                {name: 'Laki-Laki', code: 'Laki-laki'},
                {name: 'Perempuan', code: 'Perempuan'},
            ],
            bloodTypeValues: ["A", "B", "O", "AB"],
            religions:['Islam','Katolik','Kristen','Hindu','Budha'],
            maritalStatus:['married','single','widow'],
            submitted:false,
            lastEducationLevels:null,
            lazyParams: null,
        }
    },
    created(){
        this.datatableService = new DatatableService();
    },
    mounted(){
        this.filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.initData();
    },
    methods:{
        initData(){
            this.datatableService
            .getData(this.route("education.levels"), this.lazyParams)
            .then((data) => {
                this.lastEducationLevels = data.data;
            })
        },
    }
}
</script>
